import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Typography,
  styled,
  useTheme,
} from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2"
import { motion } from "framer-motion"
import React, { forwardRef, useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  COLUMNSAPROBADASEQUIPO,
  COLUMNSINGRESADASEQUIPO,
  COLUMNSLICENCIASAPROBADAS,
  COLUMNSLICENCIASINGRESADAS,
  COLUMNSNOADMITIDAS,
  COLUMNSNOAPROBADASEQUIPO,
} from "../columnas/columnasLicencias"
import {
  aprobarRechazarLicencia,
  equipoIngresadas,
  equipoNoAdmitidas,
  equipoSolicitudesAprobadas,
  ingresadas,
  misSolicitudesAprobadas,
  misSolicitudesNoAdmitidas,
  solicitudLicencia,
} from "../Redux/licencias"
import Header from "./Header"

import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import Tab from "@mui/material/Tab"

import moment from "moment/moment"
import { UserAuth } from "../context/AuthContext"
import TokenContext from "../context/TokenContext"
import ModalLicencias from "./modales/ModalLicencias"
import ModalLicenciasEquipo from "./modales/ModalLicenciasEquipo"
import ModalSolicitudLicencia from "./modales/ModalSolicitudLicencia"
import TablaLicencias from "./tablas/TablaLicencias"
import { cargarAdjuntoSolicitud } from "../Redux/solicitudes"
import { useLocation } from "react-router-dom"
import { analytics } from '../Firebase'
import useLider from "./hooks/useLider"
const Licencias = () => {
  const dispatch = useDispatch()
  const token = useContext(TokenContext)
  const theme = useTheme()
  const { empleado } = UserAuth()
  const { lider } = useLider()
  const location = useLocation();
  const [openSolicitud, setOpenSolicitud] = React.useState(false)
  const [openModal, setOpenModal] = React.useState(false)
  const [openModalEquipo, setOpenModalEquipo] = React.useState(false)
  const [adjuntarCertificado, setAdjuntarCertificado] = React.useState(false)
  const [requiereInformacion, setRequiereInformacion] = React.useState(false)

  const [lic, setLic] = React.useState({})

  const ingresadasSelector = useSelector((store) => store.licencias.licenciasIngresadas)
  const getLicenciaSelector = useSelector((store) => store.licencias.getLicencia)
  const [getLicencia, setGetLicencia] = React.useState(false)
  const [lIngresadas, setLingresadas] = React.useState([])
  const [columnasIngresadas, setColumnasIngresadas] = React.useState(COLUMNSLICENCIASINGRESADAS)

  const misSolicitudAprobSelector = useSelector((store) => store.licencias.misSolicitudesAprobadas)
  const getLicenciaAprobadasSelector = useSelector((store) => store.licencias.getLicenciaAprobadas)
  const [getLicenciaAprobadas, setGetLicenciaAprobadas] = React.useState(false)
  const [lAprobadas, setLaprobadas] = React.useState([])
  const [columnasLicenciasAprob, setColumnasLicenciasAprob] = React.useState(COLUMNSLICENCIASAPROBADAS)

  const misSolicitudNoAdSelector = useSelector((store) => store.licencias.misSolicitudesNoAdmitidas)
  const getLicenciaNoAprobadasSelector = useSelector((store) => store.licencias.getLicenciaNoAprobadas)
  const [getLicenciaNoAprobadas, setGetLicenciaNoAprobadas] = React.useState(false)
  const [noAdmitidas, setNoAdmitidas] = React.useState([])
  const [columnasNoAdm, setColumnasNoAdm] = React.useState(COLUMNSNOADMITIDAS)

  const equipoIngresadasSelector = useSelector((store) => store.licencias.ingresadasEquipo)
  const getEquipoIngresadasSelector = useSelector((store) => store.licencias.getEquipoIngresadas)
  const [getEquipoIngresadas, setGetEquipoIngresadas] = React.useState(false)
  const [ingresaEquipo, setIngresaEquipo] = React.useState([])
  const [columnasIngresadasEquipo, setColumnasIngresadasEquipo] = React.useState(COLUMNSINGRESADASEQUIPO)

  const equipoAprobadasSelector = useSelector((store) => store.licencias.aprobadasXmiEquipo)
  const getEquipoAprobadasSelector = useSelector((store) => store.licencias.getEquipoAprobadas)
  const [getEquipoAprobadas, setGetEquipoAprobadas] = React.useState(false)
  const [aprobadasEquipo, setAprobadasEquipo] = React.useState([])
  const [columnasAprobadasEquipo, setColumnasAprobadasEquipo] = React.useState(COLUMNSAPROBADASEQUIPO)

  const equipoNoAdmSelector = useSelector((store) => store.licencias.noAdmitidasEquipo)
  const getEquipoNoAdmitidasSelector = useSelector((store) => store.licencias.getEquipoNoAdmitidas)
  const [getEquipoNoAdmitidas, setGetEquipoNoAdmitidas] = React.useState(false)
  const [noAprobadasEquipo, setNoAprobadasEquipo] = React.useState([])
  const [columnasNoAprobadasEquipo, setColumnasNoAprobadasEquipo] = React.useState(COLUMNSNOAPROBADASEQUIPO)

  const [valuePrimerTab, setValuePrimerTab] = React.useState("1") //value del tablist
  const [valueSegundoTab, setValueSegundoTab] = React.useState("1") //value del tablist

  console.log(lider)

  React.useEffect(() => {
    if (empleado && empleado.usuarioPortalRh) {
      // Extraer el nombre de usuario de la dirección de correo electrónico
      const userEmail = empleado.usuarioPortalRh;
      const userName = userEmail.split('@')[0];

      // Enviar el evento a Firebase Analytics con el nombre de usuario
      analytics.logEvent('screen_view', {
        screen_name: location.pathname,
        user_email: userName,
      });
    }
  }, [empleado, location]);

  React.useEffect(() => {
    if (token && Object.keys(empleado).length > 0) {
      dispatch(ingresadas(token, empleado.usuarioPortalRh))
      dispatch(misSolicitudesAprobadas(token, empleado.usuarioPortalRh))
      dispatch(misSolicitudesNoAdmitidas(token, empleado.usuarioPortalRh))
      dispatch(equipoIngresadas(token, empleado.usuarioPortalRh))
      dispatch(equipoSolicitudesAprobadas(token, empleado.usuarioPortalRh))
      dispatch(equipoNoAdmitidas(token, empleado.usuarioPortalRh))
    }
  }, [token, empleado])
  // Ingresadas
  React.useEffect(() => {
    if (ingresadasSelector?.length > 0 && getLicenciaSelector) {
      var array = []
      ingresadasSelector.forEach((element) => {
        var objeto = {
          id: element["new_licenciaid"],
          new_diassolicitados: element["new_diassolicitados@OData.Community.Display.V1.FormattedValue"],
          new_fechadesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          new_fechahasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          new_fechadesdeModal: moment(element["new_fechadesde@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_fechahastaModal: moment(element["new_fechahasta@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_name: element.new_name,
          empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          diasSolicitados: element.new_diassolicitados,
          statuscode: element["statuscode"],
          statuscodeValue: element["statuscode"],
        }
        array.push(objeto)
      })
      setLingresadas(array)
      setGetLicencia(getLicenciaSelector)
    } else if (ingresadasSelector?.length === 0 && getLicenciaSelector) {
      setGetLicencia(getLicenciaSelector)
    }
  }, [getLicenciaSelector, ingresadasSelector])
  // Mis solicitudes aprobadas
  React.useEffect(() => {
    if (misSolicitudAprobSelector?.length > 0 && getLicenciaAprobadasSelector) {
      var array = []
      misSolicitudAprobSelector.forEach((element) => {
        var objeto = {
          id: element["new_licenciaid"],
          new_diassolicitados: element["new_diassolicitados@OData.Community.Display.V1.FormattedValue"],
          new_fechadesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          new_fechahasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          new_fechadesdeModal: moment(element["new_fechadesde@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_fechahastaModal: moment(element["new_fechahasta@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_name: element.new_name,
          empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          diasSolicitados: element.new_diassolicitados,
          statuscode: element["statuscode"],
        }
        array.push(objeto)
      })
      setLaprobadas(array)
      setGetLicenciaAprobadas(getLicenciaAprobadasSelector)
    } else if (misSolicitudAprobSelector?.length === 0 && getLicenciaAprobadasSelector) {
      setGetLicenciaAprobadas(getLicenciaAprobadasSelector)
    }
  }, [misSolicitudAprobSelector, getLicenciaAprobadasSelector])
  //Mis solicitudes no admitidas
  React.useEffect(() => {
    if (misSolicitudNoAdSelector?.length > 0 && getLicenciaNoAprobadasSelector) {
      var array = []
      misSolicitudNoAdSelector.forEach((element) => {
        var objeto = {
          id: element["new_licenciaid"],
          new_diassolicitados: element["new_diassolicitados@OData.Community.Display.V1.FormattedValue"],
          new_fechadesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          new_fechahasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          new_fechadesdeModal: moment(element["new_fechadesde@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_fechahastaModal: moment(element["new_fechahasta@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_name: element.new_name,
          empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          diasSolicitados: element.new_diassolicitados,
          statuscode: element["statuscode"],
        }
        array.push(objeto)
      })
      setNoAdmitidas(array)
      setGetLicenciaNoAprobadas(getLicenciaNoAprobadasSelector)
    } else if (misSolicitudNoAdSelector?.length === 0 && getLicenciaNoAprobadasSelector) {
      setGetLicenciaNoAprobadas(getLicenciaNoAprobadasSelector)
    }
  }, [misSolicitudNoAdSelector, getLicenciaNoAprobadasSelector])
  //Equipo ingresadas
  React.useEffect(() => {
    if (equipoIngresadasSelector?.length > 0 && getEquipoIngresadasSelector) {
      var array = []
      equipoIngresadasSelector.forEach((element) => {
        var objeto = {
          id: element["new_licenciaid"],
          new_fechadesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          new_fechadesdeModal: moment(element["new_fechadesde@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_fechahasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          new_fechahastaModal: moment(element["new_fechahasta@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_name: element.new_name,
          diasSolicitados: element.new_diassolicitados,
          empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          comentarios: element.new_comentarios,
          licenciaProlongada: element.new_licenciaprolongada,
          nombreAprobador: element["_new_aprobador1_value@OData.Community.Display.V1.FormattedValue"],
          idAprobador1: element["_new_aprobador1_value"],
          nombreValidadorLider: element["_new_validador1_value@OData.Community.Display.V1.FormattedValue"],
          idValidador1: element["_new_validador1_value"],
          nombreValidadorRRHH: element["_new_validadorrecursoshumanos_value@OData.Community.Display.V1.FormattedValue"],
          idValidadorRRHH: element["_new_validadorrecursoshumanos_value"],
          statuscode: element["statuscode"],
        }
        array.push(objeto)
      })
      setIngresaEquipo(array)
      setGetEquipoIngresadas(getEquipoIngresadasSelector)
    } else if (equipoIngresadasSelector?.length === 0 && getEquipoIngresadasSelector) {
      setGetEquipoIngresadas(getEquipoIngresadasSelector)
    }
  }, [equipoIngresadasSelector, getEquipoIngresadasSelector])
  //Equipo aprobadas por mi
  React.useEffect(() => {
    if (equipoAprobadasSelector?.length > 0 && getEquipoAprobadasSelector) {
      var array = []
      equipoAprobadasSelector.forEach((element) => {
        var objeto = {
          id: element["new_licenciaid"],
          new_fechadesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          new_fechadesdeModal: moment(element["new_fechadesde@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_fechahasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          new_fechahastaModal: moment(element["new_fechahasta@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_name: element.new_name,
          diasSolicitados: element.new_diassolicitados,
          empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          comentarios: element.new_comentarios,
          licenciaProlongada: element.new_licenciaprolongada,
          nombreAprobador: element["_new_aprobador1_value@OData.Community.Display.V1.FormattedValue"],
          idAprobador1: element["_new_aprobador1_value"],
          nombreValidadorLider: element["_new_validador1_value@OData.Community.Display.V1.FormattedValue"],
          idValidador1: element["_new_validador1_value"],
          nombreValidadorRRHH: element["_new_validadorrecursoshumanos_value@OData.Community.Display.V1.FormattedValue"],
          idValidadorRRHH: element["_new_validadorrecursoshumanos_value"],
          statuscode: element["statuscode"],
        }
        array.push(objeto)
      })
      setAprobadasEquipo(array)
      setGetEquipoAprobadas(getEquipoAprobadasSelector)
    } else if (equipoAprobadasSelector?.length === 0 && getEquipoAprobadasSelector) {
      setGetEquipoAprobadas(getEquipoAprobadasSelector)
    }
  }, [equipoAprobadasSelector, getEquipoAprobadasSelector])
  //Equipo no aprobadas
  React.useEffect(() => {
    if (equipoNoAdmSelector?.length > 0 && getEquipoNoAdmitidasSelector) {
      var array = []
      equipoNoAdmSelector.forEach((element) => {
        var objeto = {
          id: element["new_licenciaid"],
          new_fechadesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          new_fechadesdeModal: moment(element["new_fechadesde@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_fechahasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          new_fechahastaModal: moment(element["new_fechahasta@OData.Community.Display.V1.FormattedValue"], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          new_name: element.new_name,
          diasSolicitados: element.new_diassolicitados,
          empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          comentarios: element.new_comentarios,
          licenciaProlongada: element.new_licenciaprolongada,
          nombreAprobador: element["_new_aprobador1_value@OData.Community.Display.V1.FormattedValue"],
          idAprobador1: element["_new_aprobador1_value"],
          nombreValidadorLider: element["_new_validador1_value@OData.Community.Display.V1.FormattedValue"],
          idValidador1: element["_new_validador1_value"],
          nombreValidadorRRHH: element["_new_validadorrecursoshumanos_value@OData.Community.Display.V1.FormattedValue"],
          idValidadorRRHH: element["_new_validadorrecursoshumanos_value"],
          statuscode: element["statuscode"],
        }
        array.push(objeto)
      })
      setNoAprobadasEquipo(array)
      setGetEquipoNoAdmitidas(getEquipoNoAdmitidasSelector)
    } else if (equipoNoAdmSelector?.length === 0 && getEquipoNoAdmitidasSelector) {
      setGetEquipoNoAdmitidas(getEquipoNoAdmitidasSelector)
    }
  }, [equipoNoAdmSelector])

  //======|| handlers del modal de solicitud ||====== //
  const handleOpenSolicitud = () => setOpenSolicitud(true)
  const handleCloseSolicitud = () => setOpenSolicitud(false)
  //================================================= //

  //handlers de los tabs
  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue)
  }
  const handleChangeSegundoTAB = (event, newValue) => {
    setValueSegundoTab(newValue)
  }

  // ==============================|| CUSTOM MAIN CARD ||============================== //
  // constant
  const headerSX = {
    "& .MuiCardHeader-action": { mr: 0 },
  }

  const MainCard = forwardRef(
    (
      {
        border = true,
        boxShadow,
        children,
        content = true,
        contentClass = "",
        contentSX = {},
        darkTitle,
        secondary,
        shadow,
        sx = {},
        title,
        ...others
      },
      ref
    ) => {
      const theme = useTheme()

      return (
        <Card
          ref={ref}
          {...others}
          sx={{
            border: border ? "1px solid" : "none",
            borderColor: theme.palette.primary[200] + 25,
            ":hover": {
              boxShadow: boxShadow ? shadow || "0 2px 14px 0 rgb(32 40 45 / 8%)" : "inherit",
            },
            ...sx,
          }}
        >
          {/* card header and action */}
          {title && (
            <CardHeader
              sx={headerSX}
              title={darkTitle ? <Typography variant="h3">{title}</Typography> : title}
              action={secondary}
            />
          )}

          {/* content & header divider */}
          {title && <Divider />}

          {/* card content */}
          {content && (
            <CardContent sx={contentSX} className={contentClass}>
              {children}
            </CardContent>
          )}
          {!content && children}
        </Card>
      )
    }
  )

  const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.tertiary[600],
    color: theme.palette.primary.light,
    overflow: "hidden",
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: `linear-gradient(210.04deg, ${theme.palette.primary[200]} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      borderRadius: "50%",
      top: -30,
      right: -180,
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: `linear-gradient(140.9deg, ${theme.palette.primary[200]} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      borderRadius: "50%",
      top: -160,
      right: -130,
    },
  }))
  // ====================================================================================== //

  //======|| handlers del modal de vista de datos ||====== //

  const handleSubmitSolicitud = (datos, selectedFiles, formData) => {
    dispatch(solicitudLicencia(token, datos))
      .then((id) => {
        if (selectedFiles.length > 0 && id.length > 0) {
          dispatch(cargarAdjuntoSolicitud(token, formData, id, 'licencia_id'))
        }
        handleCloseSolicitud()
        dispatch(ingresadas(token, empleado.usuarioPortalRh))
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const handleSubmitLicenEquipo = (estado) => {
    dispatch(aprobarRechazarLicencia(token, estado))
      .then((id) => {
        handleCloseModalEquipo()
        if (id.length > 0) {
          dispatch(equipoIngresadas(token, empleado.usuarioPortalRh))
          dispatch(equipoSolicitudesAprobadas(token, empleado.usuarioPortalRh))
          dispatch(equipoNoAdmitidas(token, empleado.usuarioPortalRh))
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  const handleCloseModal = () => {
    setOpenModal(false)
    setAdjuntarCertificado(false)
    setRequiereInformacion(false)
    setLic({})
  }

  const handleOpenModalLicencias = (id, licencia) => {

    if (licencia.statuscodeValue == 100000005) {
      setRequiereInformacion(true);
    } else {
      setAdjuntarCertificado(true);
    }
    setLic(licencia);
    setOpenModal(true);
  };

  const handleCloseModalEquipo = () => {
    setOpenModalEquipo(false)
    setLic({})
  }

  const handleOpenModalNOADM = (id, licencia) => {
    setLic(licencia)
    setOpenModal(true)
  }

  const handleOpenModalIngEquip = (id, licencia) => {
    setLic(licencia)
    setOpenModalEquipo(true)
  }
  //======================================================= //

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1.5rem 2.5rem">
        <Header title={"Licencias"} subtitle="Gestioná en esta sección tus licencias personales y beneficios como Días Siglo" />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <Box sx={{ p: 2 }}>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                Solicita una licencia tanto para vos como para cualquier miembro de tu equipo.
              </Typography>
              <CardWrapper border={false} content={false} sx={{ mt: 2 }}>
                {/* <Box sx={{ p: 2 }}>
                  <List sx={{ py: 0 }}>
                    <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                      <ListItemAvatar>
                        <Avatar
                          variant="rounded"
                          sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.largeAvatar,
                            backgroundColor: theme.palette.primary[800],
                            color: "#fff",
                          }}
                        >
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        sx={{
                          py: 0,
                          mt: 0.45,
                          mb: 0.45,
                        }}
                        primary={
                          <Typography variant="h3" sx={{ color: "#fff" }}>
                            {empleado.nombre}
                          </Typography>
                        }
                        secondary={<Typography variant="subtitle1" sx={{ color: "primary.light", mt: 0.25 }}></Typography>}
                      />
                    </ListItem>
                  </List>
                </Box> */}
                <Divider />
                <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
                  <Button variant="contained" onClick={handleOpenSolicitud}>
                    Solicitar
                  </Button>
                </Box>
              </CardWrapper>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <Box sx={{ p: 2 }}>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                Accedé a tus licencias y observa el estado de las mismas acá. También podés ver las licencias solicitadas por tu equipo que deberás aprobar o rechazar.
              </Typography>
              <TabContext value={valuePrimerTab}>
                <Typography variant="h6" component="div" sx={{ fontWeight: "bold", mb: 1 }}>
                  MIS SOLICITUDES
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <TabList
                    aria-label="scrollable force tabs example"
                    onChange={handleChangePrimerTAB}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    textColor="secondary"
                    indicatorColor="secondary"
                  >
                    <Tab label="Ingresadas" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                    <Tab label="Mis solicitudes aprobadas" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                    <Tab label="Mis solicitudes no admitidas" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <Box sx={{ maxWidth: "100%" }}>
                    {!getLicencia ? (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                          py: 2,
                        }}
                      >
                        <CircularProgress color="secondary" />
                      </Box>
                    ) : lIngresadas.length > 0 ? (
                      <TablaLicencias
                        columnas={columnasIngresadas}
                        lineas={lIngresadas}
                        handleOpen={handleOpenModalLicencias}
                        acciones={true}
                      />
                    ) : (
                      <Alert severity="info">
                        <AlertTitle>Info</AlertTitle>
                        Aún no tienes registros de <strong>Ingresadas</strong>.
                      </Alert>
                    )}
                  </Box>
                </TabPanel>
                <TabPanel value="2">
                  {!getLicenciaAprobadas ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        py: 2,
                      }}
                    >
                      <CircularProgress color="secondary" />
                    </Box>
                  ) : lAprobadas.length > 0 ? (
                    <TablaLicencias
                      columnas={columnasLicenciasAprob}
                      lineas={lAprobadas}
                      handleOpen={handleOpenModalLicencias}
                      acciones={true}
                    />
                  ) : (
                    <Alert severity="info">
                      <AlertTitle>Info</AlertTitle>
                      Aún no tienes registros de <strong>Mis solicitudes aprobadas</strong>.
                    </Alert>
                  )}
                </TabPanel>
                <TabPanel value="3">
                  {!getLicenciaNoAprobadas ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        py: 2,
                      }}
                    >
                      <CircularProgress color="secondary" />
                    </Box>
                  ) : noAdmitidas.length > 0 ? (
                    <TablaLicencias
                      columnas={columnasNoAdm}
                      lineas={noAdmitidas}
                      handleOpen={handleOpenModalNOADM}
                      acciones={true}
                    />
                  ) : (
                    <Alert severity="info">
                      <AlertTitle>Info</AlertTitle>
                      Aún no tienes registros de <strong>Mis solicitudes no admitidas</strong>.
                    </Alert>
                  )}
                </TabPanel>
              </TabContext>
              {
                lider && (
                  <TabContext value={valueSegundoTab}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: "bold", mb: 1 }}>
                      MI EQUIPO
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <TabList
                        aria-label="scrollable force tabs example"
                        onChange={handleChangeSegundoTAB}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        textColor="secondary"
                        indicatorColor="secondary"
                      >
                        <Tab label="Ingresadas" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                        <Tab label="Aprobadas por mi" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                        <Tab label="No admitidas" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      {!getEquipoIngresadas ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : ingresaEquipo.length > 0 ? (
                        <TablaLicencias
                          columnas={columnasIngresadasEquipo}
                          lineas={ingresaEquipo}
                          handleOpen={handleOpenModalIngEquip}
                          acciones={true}
                        />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>Mis solicitudes Ingresadas equipo</strong>.
                        </Alert>
                      )}
                    </TabPanel>
                    <TabPanel value="2">
                      {!getEquipoAprobadas ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : aprobadasEquipo.length > 0 ? (
                        <TablaLicencias columnas={columnasAprobadasEquipo} lineas={aprobadasEquipo} />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>Solicitudes aprobadas por mi</strong>.
                        </Alert>
                      )}
                    </TabPanel>
                    <TabPanel value="3">
                      {!getEquipoNoAdmitidas ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : noAprobadasEquipo.length > 0 ? (
                        <TablaLicencias columnas={columnasNoAprobadasEquipo} lineas={noAprobadasEquipo} />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>Mis solicitudes no aprobadas</strong>.
                        </Alert>
                      )}
                    </TabPanel>
                  </TabContext>
                )
              }

            </Box>
          </Grid>
        </Grid>
        {openSolicitud && <ModalSolicitudLicencia open={openSolicitud} handleClose={handleCloseSolicitud} onSubmit={handleSubmitSolicitud} />}
        {openModal && Object.keys(lic).length > 0 && (
          <ModalLicencias
            open={openModal}
            handleClose={handleCloseModal}
            licencia={lic}
            adjuntarCertificado={adjuntarCertificado}
            requiereInformacion={requiereInformacion}
          />
        )}
        {openModalEquipo && <ModalLicenciasEquipo open={openModalEquipo} handleClose={handleCloseModalEquipo} licencia={lic} onSubmit={handleSubmitLicenEquipo} />}
      </Box>
    </motion.div>
  )
}

export default Licencias
